import { lazy, Suspense } from 'react';
import { useUser } from '../../contexts/UserContext';

const Content = lazy(
  () =>
    import(
      /* webpackChunkName: "content" */ '../../../layout/components/Content'
    ),
);

function AuthContainer() {
  const { user } = useUser();

  if (!user) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <Content />
    </Suspense>
  );
}

export default AuthContainer;
